import React, { FC, ReactElement, useContext } from 'react'
import { Location, NavigateFunction, useLocation, useNavigate } from 'react-router'
import CLanguageHandler from '../../../../../NonReact/Languages/LanguageHandler'
import { LanguageContext } from '../../../../../React/Common/Contexts'
import { RoundedButton } from '../../../Atoms/RoundedButton/RoundedButton'
import { ChangeLangLanguage } from '../../../../../../i18n'
import { AUTH_ROUTE_PATH } from '../../../../Constants/Constants'
import { setSessionLanguage } from '../../../../../React/Common/API/LanguageAPI'
import { displayError } from '../../../../../React/Common/Utils/Messages'
import { LOCALE_COOKIE } from '../../../Molecules/LoginForm/Constants/Constants'
import { deleteCookie, setCookie } from '../../../../../NonReact/utils/StorageUtils'

type Props = {
    selectedLanguage: string
    rememberLanguage: boolean
}

export const FooterActions: FC<Props> = ({ selectedLanguage, rememberLanguage }: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler

    const location: Location = useLocation()
    const navigate: NavigateFunction = useNavigate()

    return (
        <div className='cl-footer'>
            <RoundedButton type='button' onClick={(): void => navigate(AUTH_ROUTE_PATH, { state: { from: location } })}>
                {language.get(ChangeLangLanguage.ChangeLang_Buttons_Cancel)}
            </RoundedButton>
            <RoundedButton
                type='button'
                onClick={(): void => {
                    setSessionLanguage(selectedLanguage)
                        .then((): void => {
                            if (rememberLanguage) {
                                setCookie(LOCALE_COOKIE, selectedLanguage)
                            } else {
                                deleteCookie(LOCALE_COOKIE)
                            }

                            language.setLanguage(selectedLanguage)
                            navigate(AUTH_ROUTE_PATH, { state: { from: location } })
                        })
                        .catch(displayError)
                }}
            >
                {language.get(ChangeLangLanguage.ChangeLang_Buttons_Apply)}
            </RoundedButton>
        </div>
    )
}
